// Auto-split from i18n.js — language: it
export default {
    translation: {
// routes & menus
        Dashboard: 'Dashboard',
        'Space Data': 'Dati Spazio',
        'Equipment Data': 'Dati Attrezzatura',
        'Meter Data': 'Dati Contatore',
        'Tenant Data': 'Dati Locatario',
        'Store Data': 'Dati Negozio',
        'Shopfloor Data': 'Dati Reparto',
        'Combined Equipment Data': 'Dati Attrezzatura Combinata',
        'Auxiliary System': 'Sistema Ausiliario',
        Microgrid: 'Microrete',
        'Energy Storage Power Station': 'Centrale di Accumulo Energia',
        'Photovoltaic Power Station': 'Centrale Fotovoltaica',
        'Fault Alarm': 'Allarme Guasto',
        Monitoring: 'Monitoraggio',
        'Advanced Reporting': 'Report Avanzati',
        'Knowledge Base': 'Base di Conoscenza',
        'Energy Category Data': 'Analisi Categoria Consumi',
        'Energy Item Data': 'Analisi Voci di Consumo',
        Carbon: 'Analisi Emissioni CO2',
        Cost: 'Analisi Costi',
        Output: 'Analisi Produzione',
        Income: 'Analisi Ricavi',
        Efficiency: 'Analisi Efficienza',
        Load: 'Analisi Carico',
        Statistics: 'Analisi Statistica',
        'Batch Analysis': 'Analisi Batch',
        Saving: 'Analisi Risparmio EnergeticoⒺ',
        Plan: 'Analisi PianoⒺ',
        Prediction: 'Analisi PrevisionaleⒺ',
        'Production': 'Produzione',
        'Space Production': 'Analisi Consumo per Produzione Spazio',
        'Equipment Tracking': 'Registro Attrezzature',
        'Equipment Comparison': 'Analisi Comparativa',
        'Shopfloor Comparison': 'Analisi Comparativa',
        'Store Comparison': 'Analisi Comparativa',
        'Space Comparison': 'Analisi Comparativa',
        'Combined Equipment Comparison': 'Analisi Comparativa',
        'Tenant Comparison': 'Analisi Comparativa',
        'Environment Monitor': 'Monitor Ambientale',
        'Meter Energy': 'Analisi Consumo Contatore',
        'Meter Prediction': 'Previsione contatoreⒺ',
        'Virtual Meter Prediction': 'Previsione contatore virtualeⒺ',
        'Offline Meter Prediction': 'Previsione contatore offlineⒺ',
        'Meter Carbon': 'Analisi Emissioni CO2 Contatore',
        'Meter Cost': 'Analisi Costi Contatore',
        'Meter Trend': 'Analisi Trend Contatore',
        'Meter Realtime': 'Analisi in Tempo Reale Contatore',
        'Meter Saving': 'Analisi Risparmio ContatoreⒺ',
        'Meter Plan': 'Analisi Piano ContatoreⒺ',
        'Master Meter Submeters Balance': 'Analisi Bilanciamento Contatore Principale-Sottocontatori',
        'Meter Batch Analysis': 'Analisi Batch Contatore',
        'Meter Comparison': 'Analisi Comparativa Contatori',
        'Meter Tracking': 'Registro Contatori',
        'Virtual Meter Saving': 'Analisi Risparmio Contatore VirtualeⒺ',
        'Virtual Meter Plan': 'Analisi Piano Contatore VirtualeⒺ',
        'Virtual Meter Energy': 'Analisi Consumo Contatore Virtuale',
        'Virtual Meter Carbon': 'Analisi Emissioni CO2 Contatore Virtuale',
        'Virtual Meter Cost': 'Analisi Costi Contatore Virtuale',
        'Virtual Meter Batch Analysis': 'Analisi Batch Contatore Virtuale',
        'Virtual Meter Comparison': 'Analisi Comparativa Contatori Virtuali',
        'Offline Meter Energy': 'Analisi Consumo Contatore Offline',
        'Offline Meter Carbon': 'Analisi Emissioni CO2 Contatore Offline',
        'Offline Meter Cost': 'Analisi Costi Contatore Offline',
        'Offline Meter Batch Analysis': 'Analisi Batch Contatore Offline',
        'Offline Meter Saving': 'Analisi Risparmio Contatore OfflineⒺ',
        'Offline Meter Plan': 'Analisi Piano Contatore OfflineⒺ',
        'Offline Meter Input': 'Inserimento Dati Contatore Offline',
        'Tenant Bill': 'Fattura Locatario',
        'Energy Flow Diagram': 'Diagramma Flusso Energia',
        'Distribution System': 'Sistema Distribuzione',
        'SVG System': 'Sistema Configurazione Visiva (SVG)',
        'Faults Data': 'Analisi Guasti',
        'Space Equipments': 'Attrezzature Spazio',
        'Combined Equipments': 'Attrezzature Combinate',
        'Energy Storage Power Station List': 'Lista Centrali Accumulo',
        'Energy Storage Power Station Details': 'Monitoraggio Attrezzatura',
        'Energy Storage Power Station Reporting': 'Report Dati',
        'Energy Storage Power Station Alarm': 'Allarme Guasto',
        'Energy Storage Power Station Maintenance': 'Manutenzione',
        'Enter Production': 'Inserimento Produzione',
        'Multiple Microgrids': 'Dati Multi-Stazione Microrete',
        'Multiple Microgrids Dashboard': 'Dashboard Multi-Stazione',
        'Multiple Microgrids List': 'Lista Centrali Microrete',
        'Single Microgrid': 'Dati Singola Stazione Microrete',
        'Single Microgrid Dashboard': 'Dashboard Singola Stazione',
        'Single Microgrid Details': 'Dati Attrezzatura',
        'Single Microgrid Fault Alarm': 'Allarme Guasto Singola Stazione',
        'Microgrid Reports': 'Report Statistici Microrete',
        'Microgrid Reports Energy': 'Report Energia Microrete',
        'Microgrid Reports Revenue': 'Report Ricavi Microrete',
        'Microgrid Reports Parameters': 'Query Dati Microrete',
        'Multiple Energy Storage Power Stations': 'Dati Multi-Stazione Accumulo',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard Multi-Stazione Accumulo',
        'Multiple Energy Storage Power Stations List': 'Lista Centrali Accumulo',
        'Single Energy Storage Power Station': 'Dati Singola Stazione Accumulo',
        'Single Energy Storage Power Station Dashboard': 'Dashboard Singola Stazione Accumulo',
        'Single Energy Storage Power Station Details': 'Dati Attrezzatura Accumulo',
        'Single Energy Storage Power Station Fault Alarm': 'Allarme Guasto Stazione Accumulo',
        'Energy Storage Power Station Reports': 'Report Statistici Accumulo',
        'Energy Storage Power Station Reports Energy': 'Report Energia Accumulo',
        'Energy Storage Power Station Reports Revenue': 'Report Ricavi Accumulo',
        'Energy Storage Power Station Reports Parameters': 'Query Dati Accumulo',
        'Photovoltaic Power Station List': 'Lista Centrali Fotovoltaiche',
        'Photovoltaic Power Station Details': 'Monitoraggio Attrezzatura',
        'Photovoltaic Power Station Reporting': 'Report Dati',
        'Photovoltaic Power Station Alarm': 'Allarme Guasto',
        'Photovoltaic Power Station Maintenance': 'Manutenzione',
        'Multiple Photovoltaic Power Stations': 'Dati Multi-Stazione Fotovoltaica',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard Multi-Stazione Fotovoltaica',
        'Multiple Photovoltaic Power Stations List': 'Lista Centrali Fotovoltaiche',
        'Single Photovoltaic Power Station': 'Dati Singola Stazione Fotovoltaica',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard Singola Stazione Fotovoltaica',
        'Single Photovoltaic Power Station Details': 'Dati Attrezzatura',
        'Single Photovoltaic Power Station Fault Alarm': 'Allarme Guasto Singola Stazione',
        'Photovoltaic Power Station Reports': 'Report Statistici Fotovoltaico',
        'Photovoltaic Power Station Reports Energy': 'Report Energia Fotovoltaico',
        'Photovoltaic Power Station Reports Revenue': 'Report Ricavi Fotovoltaico',
        'Photovoltaic Power Station Reports Parameters': 'Query Dati Fotovoltaico',
        'Work Order': 'Gestione Ordini di Lavoro',
        'Work Order Installation': 'Registro Installazioni',
        'Work Order Repair': 'Registro Riparazioni',
        'Work Order Inspection': 'Registro Ispezioni',
        'Total Number of Work Orders': 'Totale Ordini di Lavoro',
        'Number of New Work Orders': 'Numero Nuovi Ordini',
        'Number of Inprogress Work Orders': 'Numero Ordini in Corso',
        'Number of Done Work Orders': 'Numero Ordini Completati',
        'Fuel Indicator': 'Consumo Carburante',
        'Charge Energy Indicator': 'Energia di Ricarica',
        'Discharge Energy Indicator': 'Energia di Scarica',
        'Charge Cost Indicator': 'Costo Ricarica',
        'Discharge Revenue Indicator': 'Ricavo Scarica',
        'HVAC': 'Climatizzazione',
        'Fire Control': 'Antincendio',
        'Store Dashboard': 'Dashboard Negozi',
        'Comprehensive overview of store energy performance': 'Panoramica completa delle prestazioni energetiche dei negozi',
        'Total Stores': 'Totale Negozi',
        'Total Area': 'Area Totale',
        'Active Meters': 'Contatori Attivi',
        'Active Alerts': 'Avvisi Attivi',
        'Total Energy Consumption': 'Consumo Energetico Totale',
        'Carbon Emissions': 'Emissioni di Carbonio',
        'Current Period': 'Periodo Corrente',
        'Energy Consumption by Category': 'Consumo Energetico per Categoria',
        'Cost Distribution by Category': 'Distribuzione dei Costi per Categoria',
        'Monthly Energy & Cost Trends': 'Tendenze Mensili di Energia e Costi',
        'Top 5 Energy Consuming Stores': 'Top 5 Negozi con Maggior Consumo Energetico',
        'Energy Category Details': 'Dettagli Categorie Energetiche',
        'Store Performance Overview': 'Panoramica Prestazioni Negozi',
        'YoY Change': 'Variazione Annuale',
        'Per m²': 'Per m²',
        'Usage Intensity': 'Intensità di Utilizzo',
        'Dashboard data loaded successfully': 'Dati dashboard caricati con successo',
        'Failed to load dashboard data': 'Caricamento dati dashboard fallito',
        'Store Name': 'Nome Negozio',
        'Store Area': 'Area Negozio',
        'Energy Consumption': 'Consumo Energetico',
        'Consumption': 'Consumo',
        'last period': 'periodo precedente',
        // Tenant Dashboard
        'Tenant Dashboard': 'Dashboard Inquilini',
        'Comprehensive overview of tenant energy performance': 'Panoramica completa delle prestazioni energetiche degli inquilini',
        'Total Tenants': 'Totale Inquilini',
        'Tenant Performance Overview': 'Panoramica Prestazioni Inquilini',
        'Tenant Name': 'Nome Inquilino',
        'Tenant Area': 'Area Inquilino',
        'Tenant Type': 'Tipo Inquilino',
        // Equipment Dashboard
        'Equipment Dashboard': 'Dashboard Apparecchiature',
        'Total Equipments': 'Totale Apparecchiature',
        'Equipment Performance Overview': 'Panoramica delle Prestazioni delle Apparecchiature',
        'Equipment Name': 'Nome Apparecchiatura',
        'Equipment Type': 'Tipo Apparecchiatura',
        'Total Energy': 'Energia Totale',
        'Total Sensors': 'Totale Sensori',
        'Increment Rate': 'Tasso di Incremento',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Totale officine',
        'Shopfloor Performance Overview': 'Panoramica delle prestazioni delle officine',
        'Shopfloor Name': 'Nome officina',
        'Shopfloor Area': 'Area officina',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Totale Attrezzature Combinate',
        'Combined Equipment Performance Overview': 'Panoramica delle Prestazioni delle Attrezzature Combinate',
        'Combined Equipment Name': 'Nome Attrezzatura Combinata',
        'Associated Equipments': 'Attrezzature Associate',


        // Dashboard
        'Welcome to QiXuan': 'Benvenuto in QiXuan',
        'An Industry Leading Energy Management System': 'Sistema di Gestione Energia All\'Avanguardia',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Consumo Anno Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Costi Anno Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Consumo Mese Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": 'Produzione Mese Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Costs CATEGORY VALUE UNIT": 'Costi Mese Corrente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year': 'Consumo Periodo Corrispondente Anno Precedente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': 'Costi Periodo Corrispondente Anno Precedente {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': 'Consumo {{CATEGORY}} {{UNIT}}',
        'CATEGORY Costs UNIT': 'Costi {{CATEGORY}} {{UNIT}}',
        // Entities
        Space: 'Spazio',
        Equipment: 'Attrezzatura',
        Meter: 'Contatore',
        'Offline Meter': 'Contatore Offline',
        'Virtual Meter': 'Contatore Virtuale',
        Tenant: 'Locatario',
        Store: 'Negozio',
        Shopfloor: 'Reparto',
        'Combined Equipment': 'Attrezzatura Combinata',
        'Cost Center': 'Centro di Costo',
        Name: 'Nome',
        DisplayName: 'Nome Visualizzato',
        UserName: 'Nome Utente',
        Description: 'Descrizione',
        'Energy Category': 'Categoria Energia',
        'Child Spaces': 'Sottospazi',
        'Associated Equipment': 'Attrezzatura Associata',
        //Energy Categories
        Electricity: 'Elettricità',
        Water: 'Acqua',
        'Natural Gas': 'Gas Naturale',
        // SidePanelModal
        Settings: 'Impostazioni',
        'Set your own customized style': 'Imposta il tuo stile personalizzato',
        'Color Scheme': 'Schema Colori',
        'Choose the perfect color mode for your app': 'Scegli la modalità colore ideale per la tua app',
        Light: 'Chiaro',
        Dark: 'Scuro',
        'RTL Mode': 'Modalità RTL',
        'Switch your language direction': 'Cambia direzione della lingua',
        'Fluid Layout': 'Layout Fluido',
        'Toggle container layout system': 'Attiva/Disattiva sistema layout container',
        'Navigation Position': 'Posizione Navigazione',
        'Vertical': 'Verticale',
        'Top': 'In Alto',
        'Combo': 'Combinato',
        'Transparent': 'Trasparente',
        'Inverted': 'Invertito',
        'Card': 'Scheda',
        'Vibrant': 'Vivace',
        'Select a suitable navigation system for your web application': 'Seleziona un sistema di navigazione adatto per la tua applicazione web',
        'Vertical Nav': 'Navigazione Verticale',
        'Top Nav': 'Navigazione in Alto',
        'Vertical Navbar Style': 'Stile Barra Navigazione Verticale',
        'Switch between styles for your vertical navbar': 'Cambia tra gli stili per la tua barra di navigazione verticale',
        Language: 'Lingua',
        'Switch between languages': 'Cambia lingua',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Ti Piace Quello che Vedi?',
        'Get QiXuan now': 'Ottieni QiXuan Ora',
        'PQ.About': 'Questa analisi copre deviazione di tensione, squilibrio di tensione, deviazione di frequenza e squilibrio di corrente. La deviazione di tensione è calcolata come (U−Un)/Un×100%; la deviazione di frequenza come |f−fn|; lo squilibrio trifase come max(|Xi−Xavg|)/Xavg×100%, richiedendo allineamento temporale dei canali trifase. I risultati si basano sulle serie temporali del contatore selezionato nel periodo di report. Se mancano canali trifase o i timestamp non sono allineati, gli indicatori di squilibrio vengono saltati. Picchi transienti o campionamenti mancanti possono amplificare i valori peggiori; per valutazioni a regime stazionario si consiglia di fare riferimento a indicatori statistici come tasso di conformità e P95.',
        Purchase: 'Acquista Edizione Enterprise',
        ContactInfo: 'Informazioni di Contatto',
        ProductWebsite: 'Sito Web del Prodotto',
        CompanyWebsite: 'Sito Web Aziendale',
        SalesPhone: 'Telefono Vendite',
        // Query Panels
        'Base Period Begins': 'Periodo Base Inizia',
        'Base Period Ends': 'Periodo Base Termina',
        'Comparison Types': 'Tipi di Confronto',
        'Year-Over-Year': 'Anno su Anno',
        'Month-On-Month': 'Mese su Mese',
        'Free Comparison': 'Confronto Libero',
        'None Comparison': 'Nessun Confronto',
        'Reporting Period Begins': 'Periodo di Report Inizia',
        'Reporting Period Ends': 'Periodo di Report Termina',
        '(Optional)': '(Opzionale)',
        'Period Types': 'Scale Temporali',
        Yearly: 'Annuale',
        Monthly: 'Mensile',
        Weekly: 'Settimanale',
        Daily: 'Giornaliero',
        Hourly: 'Orario',
        Submit: 'Invia',
        'Input Energy Category': 'Categoria Energia Input',
        'Output Energy Category': 'Categoria Energia Output',
        'Fraction Parameter': 'Parametro Frazionario',
        Search: 'Cerca',
        //DateRangePicker
        sunday: 'Dom',
        monday: 'Lun',
        tuesday: 'Mar',
        wednesday: 'Mer',
        thursday: 'Gio',
        friday: 'Ven',
        saturday: 'Sab',
        ok: 'OK',
        today: 'Oggi',
        yesterday: 'Ieri',
        hours: 'Ore',
        minutes: 'Minuti',
        seconds: 'Secondi',
        last7Days: 'Ultimi 7 Giorni',
        tomorrow: 'Domani',
        dayAfterTomorrow: 'Dopodomani',
        next7Days: 'Prossimi 7 giorni',
        'Select Date Range': 'Seleziona Intervallo Date',
        //Card Summaries and Line Charts
        'Base Period': 'Periodo Base',
        'Reporting Period': 'Periodo di Report',
        'Per Unit Area': 'Per Unità di Superficie',
        'Per Capita': 'Pro Capite',
        'Per Unit Production': 'Per Unità di Prodotto',
        Baseline: 'Valore Baseline',
        Actual: 'Valore Attuale',
        'Baseline Value - Actual Value': 'Valore Baseline - Valore Attuale',
        'Average Load': 'Carico Medio',
        'Maximum Load': 'Carico Massimo',
        'Load Factor': 'Fattore di Carico',
        'Ratio of Average Load to Maximum Load': 'Rapporto Carico Medio / Carico Massimo',
        'Carbon Dioxide Emissions by Energy Category': 'Emissioni CO2 per Categoria Energia',
        'Costs by Energy Category': 'Costi per Categoria Energia',
        'Incomes by Energy Category': 'Ricavi per Categoria Energia',
        'Electricity Consumption by Time-Of-Use': 'Consumo Elettrico per Fascia Oraria',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Emissioni CO2 Elettriche per Fascia Oraria',
        'Electricity Cost by Time-Of-Use': 'Costo Elettrico per Fascia Oraria',
        'CATEGORY UNIT Consumption by Energy Items': 'Consumo {{CATEGORY}} {{UNIT}} per Voci di Energia',
        'Ton of Standard Coal by Energy Category': 'Tonnellate Carbone Standard (TCE) per Categoria Energia',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Tonnellate Emissioni CO2 (TCO2E) per Categoria Energia',
        'Reporting Period Consumption CATEGORY UNIT': 'Consumo Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Previsione Periodo Report {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT': 'Consumo {{EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            'Consumo {{COMBINED_EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Produzione Periodo Report {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Produzione Periodo Base {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Consumo Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Previsione Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Consumo Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Previsione Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Consumo Periodo Report {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': 'Consumo Periodo Report {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': 'Consumo Periodo Base {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Proporzione Sottospazi {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Proporzione Totale Sottospazi',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': 'Emissioni CO2 Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Emissioni CO2 Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': 'Emissioni CO2 Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Costi Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Costi Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Costi Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Produzione Periodo Report {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': 'Produzione {{EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            'Produzione {{COMBINED_EQUIPMENT}} Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Produzione Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Produzione Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Ricavi Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Ricavi Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Ricavi Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Ricavi Totali Periodo Report {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Efficienza Cumulativa Periodo Report {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT': 'Efficienza Cumulativa {{EQUIPMENT}} Periodo Report {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            'Efficienza Cumulativa Complessiva {{COMBINED_EQUIPMENT}} Periodo Report {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            'Efficienza Cumulativa Complessiva {{COMBINED_EQUIPMENT}} Periodo Report {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            'Efficienza Cumulativa Complessiva {{COMBINED_EQUIPMENT}} Periodo Base {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Efficienza Istantanea {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': 'Efficienza Istantanea {{EQUIPMENT}} {{UNIT}}',
        'Equipment Efficiency Indicator': "Indicatore di Efficienza Energetica dell'Apparecchiatura",
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': 'Efficienza Istantanea Complessiva {{COMBINED_EQUIPMENT}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Efficienza Cumulativa Periodo Report {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': 'Efficienza Cumulativa Periodo Report {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Efficienza Cumulativa Periodo Base {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': 'Efficienza Cumulativa Periodo Base {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Carico Massimo {{CATEGORY}} Periodo Base {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Carico Massimo {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Carico Medio {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Fattore di Carico {{CATEGORY}} Periodo Report',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Carico Medio {{CATEGORY}} Periodo Base {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Media {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Massimo {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Minimo {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Media Aritmetica {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Mediana {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Deviazione Standard Campione {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Varianza Campione {{CATEGORY}} Periodo Report {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': 'Risparmio Periodo Report {{CATEGORY}} (Baseline - Attuale) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': 'Riduzione Periodo Report {{CATEGORY}} (Baseline - Attuale) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Risparmio Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Risparmio Periodo Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': 'Consumo Contatore Principale Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': 'Consumo Contatore Principale Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': 'Consumo Sottocontatori Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT': 'Consumo Sottocontatori Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Differenza Periodo Report {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Differenza Percentuale Periodo Report',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Differenza Periodo Report {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': 'Valori di Trend',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Lista Guasti',
        'Reporting Period Number of Fault VALUE': 'Numero Guasti Periodo Report: {{VALUE}}',
        'All Faults': 'Tutti i Guasti',
        'Space Faults': 'Guasti Spazio',
        'Number of All Faults': 'Numero Totale Guasti',
        'Number of Space Faults': 'Numero Guasti Spazio',
        'Total Number of Faults': 'Numero Totale Guasti',
        'Number of New Faults': 'Numero Nuovi Guasti',
        'Number of Inprogress Faults': 'Numero Guasti in Corso',
        'Number of Done Faults': 'Numero Guasti Completati',
        //Data Panels
        'Ton of Standard Coal': 'Tonnellate Carbone Standard',
        'Ton of Carbon Dioxide Emissions': 'Tonnellate Emissioni CO2',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Emissioni CO2 per Unità di Consumo Energetico',
        'Operating Characteristic Curve': 'Curva Caratteristica di Funzionamento',
        Tariff: 'Tariffa',
        'Detailed Data': 'Dati Dettagliati',
        'Child Spaces Data': 'Dati Sottospazi',
        'Associated Equipment Data': 'Dati Attrezzatura Associata',
        'This Year': 'Anno Corrente',
        'The Same Period Last Year': 'Stesso Periodo Anno Precedente',
        'This Month': 'Mese Corrente',
        'This Day': 'Giorno Corrente',
        Total: 'Totale',
        'No data found': 'Nessun Dato Trovato',
        Export: 'Esporta',
        'AI Analysis': 'Analisi IA',
        Datetime: 'Data/Ora',
        'Time-Of-Use Type': 'Tipo Fascia Oraria',
        'Top-Peak': 'Punta',
        'On-Peak': 'Picco',
        'Mid-Peak': 'Normale',
        'Off-Peak': 'Fuori Picco',
        'Deep': 'Valle Profonda',
        Percentage: 'Percentuale',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Trend Ultima Ora Punto Valore Energia',
        Circuit: 'Circuito',
        Point: 'Punto Dati',
        'Realtime Value': 'Valore in Tempo Reale',
        //Meter Tracking
        'Meter List': 'Lista Contatori',
        'Edit Meter': 'Modifica',
        'Start Value': 'Valore Iniziale',
        'End Value': 'Valore Finale',
        'Difference Value': 'Differenza',
        'Start Integrity Rate': 'Tasso Integrità Dati Iniziale (%)',
        'End Integrity Rate': 'Tasso Integrità Dati Finale (%)',
        'Full Integrity Rate': 'Tasso Integrità Dati Complessivo (%)',
        'Start Integrity Rate Description': 'Tasso di Integrità Dati Iniziale: Proporzione di contatori che hanno ottenuto con successo letture di consumo energetico all\'ora di inizio tra tutti i contatori durante il periodo statistico',
        'End Integrity Rate Description': 'Tasso di Integrità Dati Finale: Proporzione di contatori che hanno ottenuto con successo letture di consumo energetico all\'ora di fine tra tutti i contatori durante il periodo statistico',
        'Full Integrity Rate Description': 'Tasso di Integrità Dati Completo: Proporzione di contatori che hanno ottenuto con successo letture di consumo energetico sia all\'ora di inizio che di fine tra tutti i contatori durante il periodo statistico',
        //Equipment Tracking
        'Equipment List': 'Lista Attrezzature',
        'Edit Equipment': 'Modifica',
        //Profile Dropdown
        Feedback: 'Feedback',
        'Account Settings': 'Impostazioni Account',
        Logout: 'Esci',
        //Authentication
        'Log in': 'Accedi',
        'Email address': 'Indirizzo Email',
        'Phone Number': 'Numero di Telefono',
        Password: 'Password',
        CaptchaCode: 'Codice di Verifica',
        Refresh: 'Aggiorna',
        'Remember me': 'Ricordami',
        'Logged in as ': 'Accesso effettuato come ',
        'Forgot Password?': 'Password Dimenticata?',
        'Forgot your password?': 'Hai Dimenticato la Password?',
        "Enter your email and we'll send you a reset link": 'Inserisci la tua email e ti invieremo un link di reset',
        "Enter your email and we'll send you a registration link": 'Inserisci la tua email e ti invieremo un link di registrazione',
        'Reset Password': 'Reimposta Password',
        'Thanks for using QiXuan!': 'Grazie per usare QiXuan!',
        'You are now successfully signed out': 'Sei uscito con successo',
        'Return to Login': 'Torna al Login',
        'Please check your email!': 'Controlla la tua email!',
        'An email has been sent to ': 'Un\'email è stata inviata a ',
        'Please click on the included link to reset your password': 'Clicca sul link incluso per reimpostare la tua password',
        'Please click on the included link to register your account': 'Clicca sul link incluso per registrare il tuo account',
        'An email with password reset link is sent to ': 'Un\'email con link di reset password è stata inviata a ',
        'Change Password': 'Cambia Password',
        'Old Password': 'Vecchia Password',
        'New Password': 'Nuova Password',
        'Confirm Password': 'Conferma Nuova Password',
        'Update Password': 'Aggiorna Password',
        'Password has been changed!': 'Password modificata!',
        'Verification code has been sent to your inbox. \
        Please copy it to the input box below.':
            'Il codice di verifica è stato inviato alla tua casella di posta. Copialo nella casella di input qui sotto.',
        'New to QiXuan': 'Nuovo su QiXuan',
        'Create an account': 'Crea un account',
        'EMAIL Account registration successful': 'Registrazione account {{EMAIL}} riuscita',
        'Thanks for verifying your account!': 'Grazie per aver verificato il tuo account!',
        'Your code is': 'Il tuo codice è',
        'Send verification code': 'Invia codice di verifica',
        'Please wait for NUMBER seconds': 'Attendi {{NUMBER}} secondi',
        'Password reset': 'Reset Password',
        'Please wait for approval': 'Attendi approvazione',
        //notification
        Notifications: 'Notifiche',
        'Mark all as read': 'Segna tutte come lette',
        'View all': 'Visualizza tutte',
        'Notification New': 'Nuove',
        'Notification Earlier': 'Precedenti',
        'Notification List': 'Lista Notifiche',
        'Bulk actions': 'Azioni di Gruppo',
        'Notification Subject': 'Oggetto',
        'Notification Created Datetime': 'Data/Ora Creazione',
        'Notification Message': 'Contenuto',
        'Notification Priority': 'Priorità',
        'Notification Status': 'Stato',
        'Notification Mark As Read': 'Segna come Letta',
        'Notification Mark As Acknowledged': 'Conferma',
        'Notification Low': 'Bassa',
        'Notification Medium': 'Media',
        'Notification High': 'Alta',
        'Notification Critical': 'Critica',
        'Notification Unread': 'Non Letta',
        'Notification Read': 'Letta',
        'Notification Acknowledged': 'Confermata',
        'Notification Archive': 'Archivia',
        'Notification Delete': 'Elimina',
        'Notification Apply': 'Applica',
        'Notification Start Datetime': 'Data/Ora Inizio',
        'Notification End Datetime': 'Data/Ora Fine',
        'Notification Update Datetime': 'Data/Ora Aggiornamento',
        //Monitoring
        'Run Commands': 'Esegui Comandi',
        'Pin Code': 'Codice PIN',
        'Unlock': 'Sblocca',
        'Set Value': 'Imposta Valore',
        'Fault Alarms': 'Allarmi Guasto',
        'Instantaneous Efficiency VALUE UNIT': 'Efficienza Istantanea {{VALUE}} {{UNIT}}',
        'Communication Status': 'Stato Comunicazione',
        'Communication Online': 'Online',
        'Communication Offline': 'Offline',
        'Equipment Status': 'Stato Attrezzatura',
        'Equipment Running': 'In Funzione',
        'Equipment Stopped': 'Fermo',
        'Show Up to': 'Mostra fino a',
        All: 'Tutti',
        'FROM - TO of TOTAL': 'Visualizzando {{FROM}} - {{TO}} di {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Energia Microrete',
        'Microgrid Revenue': 'Ricavi Microrete',
        'Microgrid Carbon': 'Carbonio Microrete',
        'Photovoltaic Generation': 'Generazione Fotovoltaica',
        'EV Charger Consumption': 'Consumo Colonnina Ricarica EV',
        'Load Consumption': 'Consumo Carico',
        'Grid Buy': 'Acquisto da Rete',
        'Grid Sell': 'Vendita alla Rete',
        'EV Charger': 'Colonnina Ricarica EV',
        'Heat Pump': 'Pompa di Calore',
        'Photovoltaic': 'Fotovoltaico',
        'PCS Run State': 'Stato Funzionamento PCS',
        'PCS Unknown': 'Sconosciuto',
        'PCS Initializing': 'Inizializzazione',
        'PCS Standby': 'Standby',
        'PCS Shutdown': 'Spento',
        'PCS Fault': 'Guasto',
        'PCS Running': 'In Funzione',
        'Battery Power': 'Potenza Batteria',
        'Photovoltaic Power': 'Potenza Fotovoltaica',
        'Grid Power': 'Potenza Rete',
        'Load Power': 'Potenza Carico',
        Reporting: 'Report Dati',
        Maintenance: 'Manutenzione',
        'General Information': 'Informazioni Generali',
        'Serial Number': 'Numero Seriale',
        Address: 'Indirizzo',
        'Postal Code': 'Codice Postale',
        'Rated Capacity': 'Capacità Nominale',
        'Rated Power': 'Potenza Nominale',
        Latitude: 'Latitudine',
        Longitude: 'Longitudine',
        'Strategy Management': 'Gestione Strategia',
        'Charging Schedule': 'Programma Ricarica',
        'Charge Start Time': 'Ora Inizio Ricarica',
        'Charge End Time': 'Ora Fine Ricarica',
        'Discharge Start Time': 'Ora Inizio Scarica',
        'Discharge End Time': 'Ora Fine Scarica',
        'Total Rated Power': 'Potenza Nominale Totale',
        'Total Rated Capacity': 'Capacità Nominale Totale',
        // Energy Indicator
        "Today's Charge": "Ricarica Oggi",
        "Today's Discharge": "Scarica Oggi",
        "Today's Generation": "Generazione Oggi",
        'Total Fuel Consumption': 'Consumo Totale Carburante',
        'Total Charge': 'Ricarica Totale',
        'Total Discharge': 'Scarica Totale',
        'Total Generation': 'Generazione Totale',
        'Total Revenue': 'Ricavi Totali',
        'Total Photovoltaic Generation': 'Generazione Fotovoltaica Totale',
        'Total EV Charger Consumption': 'Consumo Totale Colonnine Ricarica EV',
        'Total Load Consumption': 'Consumo Totale Carico',
        'Total Grid Buy': 'Acquisto Totale da Rete',
        'Total Grid Sell': 'Vendita Totale alla Rete',
        'Total Efficiency': 'Efficienza Complessiva',
        'Discharge Achievement Rate': 'Tasso di Realizzazione Scarica',
        // Revenue Indicator
        "Today's Cost": "Costo Oggi",
        "Today's Income": "Ricavo Oggi",
        "Total Cost": "Costo Totale",
        "Total Income": "Ricavo Totale",
        "Today's Revenue": "Profitto Oggi",

        'Revenue Ranking': 'Classifica Ricavi',
        'Efficiency Ranking': 'Classifica Efficienza',
        'Charge Ranking': 'Classifica Ricarica',
        'Discharge Ranking': 'Classifica Scarica',
        'Number of Microgrids': 'Numero Microreti',
        'Number of Power Stations': 'Numero Centrali',
        'Microgrid List': 'Lista Microreti',
        'Select Microgrid': 'Seleziona Microrete',
        'Previous Page': 'Pagina Precedente',
        'Next Page': 'Pagina Successiva',
        '7 Days': '7 Giorni',
        'Charge UNIT': 'Carica {{UNIT}}',
        'Discharge UNIT': 'Scarica {{UNIT}}',
        'Generation UNIT': 'Genera {{UNIT}}',
        'Energy Indicator': 'Energia',
        'Revenue Indicator': 'Ricavi',
        'Carbon Indicator': 'Carbonio',

        // Energy Storage Power Station
        'Battery Operating State': 'Stato Operativo Batteria',
        'Battery State': 'Stato Batteria',
        'Battery Unknown': 'Sconosciuto',
        'Battery Stopped': 'Fermo',
        'Battery Reserved': 'Reserved',
        'Battery Fault': 'Guasto',
        'Battery Warning': 'Avviso',
        'Battery Standby': 'Standby',
        'Battery Prohibit DisCharging': 'Scarica Bloccata',
        'Battery Prohibit Charging': 'Ricarica Bloccata',
        'Battery Normal': 'Normale',
        'Battery Charging': 'In Carica',
        'Battery Discharging': 'In Scarica',
        'Battery Idle': 'Inattiva',
        'Phase of Lifecycle': 'Fase Ciclo Vita',
        'Use Phase': 'In Uso',
        'Commissioning Phase': 'Messa in Servizio',
        'Commissioning Date': 'Data Attivazione',
        'Installation Phase': 'In Costruzione',
        'Device Status': 'Stato Dispositivo',
        'Basic Information': 'Informazioni Base',
        'Gateway': 'Gateway',
        'Grid Meter': 'Contatore Rete',
        'Load Meter': 'Contatore Carico',
        'ESS Meter': 'Contatore Sistema Accumulo (ESS)',
        'Total Active Power': 'Potenza Attiva Totale',
        'Active Power A': 'Potenza Attiva Fase A',
        'Active Power B': 'Potenza Attiva Fase B',
        'Active Power C': 'Potenza Attiva Fase C',
        'Total Reactive Power': 'Potenza Reattiva Totale',
        'Reactive Power A': 'Potenza Reattiva Fase A',
        'Reactive Power B': 'Potenza Reattiva Fase B',
        'Reactive Power C': 'Potenza Reattiva Fase C',
        'Total Apparent Power': 'Potenza Apparente Totale',
        'Apparent Power A': 'Potenza Apparente Fase A',
        'Apparent Power B': 'Potenza Apparente Fase B',
        'Apparent Power C': 'Potenza Apparente Fase C',
        'Total Power Factor': 'Fattore di Potenza Totale',
        'Active Energy Import': 'Energia Attiva Importata',
        'Active Energy Export': 'Energia Attiva Esportata',
        'Active Energy Net': 'Energia Attiva Netta',

        'Generator': 'Generatore',

        // Photovoltaic Power Station
        'Invertor': 'Inverter',
        'Invertor Run State': 'Stato Funzionamento Inverter',
        'Invertor Unknown': 'Sconosciuto',
        'Invertor Initializing': 'Inizializzazione',
        'Invertor Standby': 'Standby',
        'Invertor Shutdown': 'Spento',
        'Invertor Fault': 'Guasto',
        'Invertor Running': 'In Funzione',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': 'Data/Ora Creazione',
        'File Format': 'Formato File',
        'File Size': 'Dimensione File',
        Uploader: 'Caricatore',
        'Upload Datetime': 'Data/Ora Caricamento',
        //Error
        "The page you're looking for is not found": 'La pagina che stai cercando non esiste',
        "Make sure the address is correct and that the page hasn't moved": 'Assicurati che l\'indirizzo sia corretto e che la pagina non sia stata spostata',
        'If you think this is a mistake,': 'Se pensi che sia un errore,',
        'contact us': 'contattaci',
        'Take me home': 'Portami alla Home',
        'Whoops, something went wrong!': 'Ops, qualcosa è andato storto!',
        'Try refreshing the page, or going back and attempting the action again':
            'Prova ad aggiornare la pagina, o torna indietro e tenta nuovamente l\'azione',
        'If this problem persists,': 'Se il problema persiste,',
        'Captcha Error': 'Errore Codice di Verifica',
        'Confirm Password Error': 'Le password non corrispondono',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Sembra che tu abbia cliccato su un link di reset password non valido. Riprova.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Sembra che tu abbia cliccato su un link di registrazione account non valido. Riprova.',
        //Tenant Bill
        'Lease Contract Number': 'Numero Contratto di Locazione',
        Download: 'Scarica',
        Print: 'Stampa',
        'Payment Notice': 'Avviso di Pagamento',
        'Bill To': 'A',
        'Bill Number': 'Numero Fattura',
        'Bill Date': 'Data Fattura',
        'Payment Due Date': 'Scadenza Pagamento',
        'Amount Payable': 'Importo da Pagare',
        'Billing Period Start': 'Inizio Periodo di Fatturazione',
        'Billing Period End': 'Fine Periodo di Fatturazione',
        Quantity: 'Quantità',
        Price: 'Prezzo',
        Unit: 'Unità',
        Amount: 'Importo',
        Subtotal: 'Subtotale',
        'VAT Output Tax': 'IVA a Debito',
        'Total Amount Payable': 'Totale da Pagare',
        'Please make sure to pay on or before the payment due date above': 'Si prega di pagare entro o prima della data di scadenza sopra indicata',
        'Send money to the following account': 'Versa l\'importo sul seguente conto',
        'Account Name': 'Intestatario Conto',
        'Bank Name': 'Banca',
        'Bank Address': 'Indirizzo Banca',
        'RMB Account': 'Conto RMB',
        // button
        'Toggle Navigation': 'Attiva/Disattiva Navigazione',
        // working calendar
        'Working Days': 'Giorni Lavorativi',
        'Non Working Days': 'Giorni Non Lavorativi',
        'Select Row': 'Seleziona la riga di dati da operare',
        // Offline Meter Input
        'Daily Value': 'Dati Giornalieri',
        Date: 'Data',
        'Successfully Saved': 'Salvato con Successo',
        'Previous Data Is Empty': 'I dati precedenti sono vuoti',

        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sessione amministratore non trovata',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Sessione amministratore scaduta',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Report avanzato non trovato',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Richiesta non valida',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Impossibile impostare un sottocontatore esistente come contatore principale',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relazione attrezzatura combinata-attrezzatura già esistente',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-attrezzatura non trovata',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relazione attrezzatura combinata-contatore già esistente',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-contatore non trovata',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nome attrezzatura combinata già in uso',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Attrezzatura combinata non trovata',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relazione attrezzatura combinata-contatore offline già esistente',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-contatore offline non trovata',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nome parametro attrezzatura combinata già in uso',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametro attrezzatura combinata non trovato o non corrispondente',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relazione attrezzatura combinata-contatore virtuale già esistente',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura combinata-contatore virtuale non trovata',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Nome contatto già in uso',
        'API.CONTACT_NOT_FOUND': 'Contatto non trovato',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'ID esterno centro di costo già esistente',
        'API.COST_CENTER_NAME_EXISTS': 'Nome centro di costo già esistente',
        'API.COST_CENTER_NOT_FOUND': 'Centro di costo non trovato',
        'API.COST_FILE_NOT_FOUND': 'File costi non trovato',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Nome sorgente dati già in uso',
        'API.DATA_SOURCE_NOT_FOUND': 'Sorgente dati non trovata',
        'API.DATABASE_ERROR': 'Errore database',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Data già presente nel calendario lavorativo',
        'API.DATE_LOCAL_NOT_FOUND': 'Data locale non trovata',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Nome circuito distribuzione già in uso',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Circuito distribuzione non trovato',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relazione circuito distribuzione-punto dati già esistente',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relazione circuito distribuzione-punto dati non trovata',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nome sistema distribuzione già in uso',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Sistema distribuzione non trovato',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email già in uso',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Messaggio email non trovato',
        'API.EMAIL_NOT_FOUND': 'Email non trovata',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Host server email già in uso',
        'API.EMAIL_SERVER_NOT_FOUND': 'Server email non trovato',
        'API.EMPTY_VARIABLES_ARRAY': 'Array variabili vuoto',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Nome categoria energia già in uso',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Categoria energia non trovata',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Categoria energia già usata nelle voci di energia',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Categoria energia già usata nei contatori',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Categoria energia già usata nei contatori offline',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Categoria energia già usata nelle tariffe',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Categoria energia già usata nei contatori virtuali',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Collegamento diagramma flusso energia già in uso',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Collegamento diagramma flusso energia non trovato o non corrispondente',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Nome diagramma flusso energia già in uso',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Nome nodo diagramma flusso energia già in uso',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Nodo diagramma flusso energia non trovato o non corrispondente',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Diagramma flusso energia non trovato',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Voce energia non appartiene alla categoria energia',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Voce energia non appartiene alla categoria energia',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Nome voce energia già in uso',
        'API.ENERGY_ITEM_NOT_FOUND': 'Voce energia non trovata',
        'API.ENERGY_ITEM_USED_IN_METER': 'Voce energia già usata nei contatori',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Voce energia già usata nei contatori offline',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Voce energia già usata nei contatori virtuali',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relazione attrezzatura-contatore già esistente',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura-contatore non trovata',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nome attrezzatura già in uso',
        'API.EQUIPMENT_NOT_FOUND': 'Attrezzatura non trovata',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relazione attrezzatura-contatore offline già esistente',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura-contatore offline non trovata',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nome parametro attrezzatura già in uso',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parametro attrezzatura non trovato o non corrispondente',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relazione attrezzatura-contatore virtuale già esistente',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione attrezzatura-contatore virtuale non trovata',
        'API.ERROR': 'Errore',
        'API.EXCEPTION': 'Eccezione',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Ripristino file costi fallito',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Ripristino file conoscenza fallito',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Ripristino file contatore offline fallito',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Salvataggio file contatore offline fallito',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Upload file costi fallito',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Upload file conoscenza fallito',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Upload file contatore offline fallito',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Nome gateway già in uso',
        'API.GATEWAY_NOT_FOUND': 'Gateway non trovato',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Non valido ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Indirizzo non valido',
        'API.INVALID_ADDRESS_VALUE': 'Valore indirizzo non valido',
        'API.INVALID_ADVANCED_REPORT_ID': 'ID report avanzato non valido',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Valore area non valido',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Data/ora fine periodo base non valida',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Data/ora inizio periodo base non valida',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Baud rate non valido',
        'API.INVALID_BUILDINGS_VALUE': 'Valore edifici non valido',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Categoria non valida',
        'API.INVALID_CHANNEL': 'Canale non valido',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'ID attrezzatura combinata non valido',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nome attrezzatura combinata non valido',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'ID parametro attrezzatura combinata non valido',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Nome parametro attrezzatura combinata non valido',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Tipo parametro attrezzatura combinata non valido',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID attrezzatura combinata non valido',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Connessione non valida',
        'API.INVALID_CONSTANT_VALUE': 'Valore costante non valido',
        'API.INVALID_CONTACT_ID': 'ID contatto non valido',
        'API.INVALID_CONTACT_NAME': 'Nome contatto non valido',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'ID centro di costo non valido',
        'API.INVALID_COST_FILE_ID': 'ID file costi non valido',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'ID sorgente dati non valido',
        'API.INVALID_DATA_SOURCE_NAME': 'Nome sorgente dati non valido',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Protocollo sorgente dati non valido',
        'API.INVALID_DATE_LOCAL': 'Data locale non valida',
        'API.INVALID_DENOMINATOR_METER_UUID': 'UUID contatore denominatore non valido',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Nome visualizzato non valido',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'ID circuito distribuzione non valido',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nome circuito distribuzione non valido',
        'API.INVALID_DISTRIBUTION_ROOM': 'Stanza distribuzione non valida',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'ID sistema distribuzione non valido',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nome sistema distribuzione non valido',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Email non valida',
        'API.INVALID_EMAIL_MESSAGE_ID': 'ID messaggio email non valido',
        'API.INVALID_EMAIL_SERVER_HOST': 'Host server email non valido',
        'API.INVALID_EMAIL_SERVER_ID': 'ID server email non valido',
        'API.INVALID_END_DATE_FORMAT': 'Formato data fine non valido',
        'API.INVALID_END_DATETIME': 'Data/ora fine non valida',
        'API.INVALID_ENERGY_CATEGORY_ID': 'ID categoria energia non valido',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Nome categoria energia non valido',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'ID diagramma flusso energia non valido',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'ID collegamento diagramma flusso energia non valido',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nome diagramma flusso energia non valido',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'ID nodo diagramma flusso energia non valido',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nome nodo diagramma flusso energia non valido',
        'API.INVALID_ENERGY_ITEM_ID': 'ID voce energia non valido',
        'API.INVALID_ENERGY_ITEM_NAME': 'Nome voce energia non valido',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Equazione non valida nell espressione',
        'API.INVALID_EQUIPMENT_ID': 'ID attrezzatura non valido',
        'API.INVALID_EQUIPMENT_NAME': 'Nome attrezzatura non valido',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'ID parametro attrezzatura non valido',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nome parametro attrezzatura non valido',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Tipo parametro attrezzatura non valido',
        'API.INVALID_EQUIPMENT_UUID': 'UUID attrezzatura non valido',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Espressione non valida',
        'API.INVALID_EXPRESSION_OBJECT': 'Oggetto espressione non valido',
        'API.INVALID_FDD_CODE': 'Codice guasto FDD non valido',
        'API.INVALID_FLOORS_VALUE': 'Valore piani non valido',
        'API.INVALID_FROM_ADDR': 'Indirizzo mittente non valido',
        'API.INVALID_GATEWAY_ID': 'ID gateway non valido',
        'API.INVALID_GATEWAY_NAME': 'Nome gateway non valido',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Valore limite superiore orario non valido',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Valore limite inferiore orario non valido',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Valore amministratore non valido',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Valore visualizzazione dati costi non valido',
        'API.INVALID_IS_COUNTED_VALUE': 'Valore conteggiato non valido',
        'API.INVALID_IS_ENABLED': 'Valore abilitazione non valido',
        'API.INVALID_IS_HIDDEN': 'Valore nascosto non valido',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Valore in locazione non valido',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Valore input conteggiato non valido',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Valore locatario principale non valido',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Valore output conteggiato non valido',
        'API.INVALID_IS_OUTPUT_VALUE': 'Valore output non valido',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Valore salvataggio trend non valido',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Valore punto virtuale non valido',
        'API.INVALID_KGCE': 'Coefficiente kg carbone standard non valido',
        'API.INVALID_KGCO2E': 'Coefficiente kg emissioni CO2 non valido',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'ID file conoscenza non valido',
        'API.INVALID_LATITUDE_VALUE': 'Valore latitudine non valido',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Valore numero contratto locazione non valido',
        'API.INVALID_LONGITUDE_VALUE': 'Valore longitudine non valido',
        'API.INVALID_LOW_LIMIT_VALUE': 'Valore limite inferiore non valido',
        'API.INVALID_MASTER_METER_ID': 'ID contatore principale non valido',
        'API.INVALID_MENU_ID': 'ID menu non valido',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Modello messaggio non valido',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'ID contatore non valido',
        'API.INVALID_METER_NAME': 'Nome contatore non valido',
        'API.INVALID_METER_UUID': 'UUID contatore non valido',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Valore nome non valido',
        'API.INVALID_NEW_PASSWORD': 'Nuova password non valida',
        'API.INVALID_NON_WORKING_DAY_ID': 'ID giorno non lavorativo non valido',
        'API.INVALID_NOTIFICATION_ID': 'ID notifica non valido',
        'API.INVALID_NUMERATOR_METER_UUID': 'UUID contatore numeratore non valido',
        'API.INVALID_OBJECT_TYPE': 'Tipo oggetto non valido',
        'API.INVALID_OFFLINE_METER_DATA': 'Dati contatore offline non validi',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'ID file contatore offline non valido',
        'API.INVALID_OFFLINE_METER_ID': 'ID contatore offline non valido',
        'API.INVALID_OFFLINE_METER_NAME': 'Nome contatore offline non valido',
        'API.INVALID_OFFLINE_METER_UUID': 'UUID contatore offline non valido',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Valore costante offset non valido',
        'API.INVALID_OLD_PASSWORD': 'Vecchia password non valida',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'ID spazio padre non valido',
        'API.INVALID_PASSWORD': 'Password non valida',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Corrente di picco non valida',
        'API.INVALID_PEAK_LOAD': 'Carico di picco non valido',
        'API.INVALID_PERIOD_TYPE': 'Tipo periodo non valido',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'ID punto dati non valido',
        'API.INVALID_POINT_NAME': 'Nome punto dati non valido',
        'API.INVALID_PORT': 'Porta non valida',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Priorità non valida',
        'API.INVALID_PRIVILEGE': 'Privilegio non valido',
        'API.INVALID_PRIVILEGE_DATA': 'Dati privilegio non validi',
        'API.INVALID_PRIVILEGE_ID': 'ID privilegio non valido',
        'API.INVALID_PRIVILEGE_NAME': 'Nome privilegio non valido',
        'API.INVALID_RATIO_VALUE': 'Valore rapporto di trasformazione non valido',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Risposta non valida',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Data/ora fine periodo report non valida',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Data/ora inizio periodo report non valida',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Richiesta autenticazione non valida',
        'API.INVALID_ROOMS_VALUE': 'Valore stanze non valido',
        'API.INVALID_RULE_ID': 'ID regola non valido',
        'API.INVALID_RULE_NAME': 'Nome regola non valido',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'ID sensore non valido',
        'API.INVALID_SENSOR_NAME': 'Nome sensore non valido',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Porta seriale non valida',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sessione non valida, eseguire nuovamente il login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'ID reparto non valido',
        'API.INVALID_SHOPFLOOR_NAME': 'Nome reparto non valido',
        'API.INVALID_SHOPFLOOR_UUID': 'UUID reparto non valido',
        'API.INVALID_SOURCE_NODE_ID': 'ID nodo sorgente non valido',
        'API.INVALID_SPACE_ID': 'ID spazio non valido',
        'API.INVALID_SPACE_NAME': 'Nome spazio non valido',
        'API.INVALID_SPACE_UUID': 'UUID spazio non valido',
        'API.INVALID_START_DATE_FORMAT': 'Formato data inizio non valido',
        'API.INVALID_START_DATETIME': 'Data/ora inizio non valida',
        'API.INVALID_STATUS': 'Stato non valido',
        'API.INVALID_STORE_ID': 'ID negozio non valido',
        'API.INVALID_STORE_NAME': 'Nome negozio non valido',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Descrizione tipo negozio non valida',
        'API.INVALID_STORE_TYPE_ID': 'ID tipo negozio non valido',
        'API.INVALID_STORE_TYPE_NAME': 'Nome tipo negozio non valido',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Codice semplificato tipo negozio non valido',
        'API.INVALID_STORE_UUID': 'UUID negozio non valido',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'SVG non valido',
        'API.INVALID_SWITCHGEAR': 'Apparecchiatura di commutazione non valida',
        'API.INVALID_TARGET_NODE_ID': 'ID nodo destinazione non valido',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Prezzo tariffa a blocchi non valido',
        'API.INVALID_TARIFF_ID': 'ID tariffa non valido',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Prezzo tariffa per fascia oraria non valido',
        'API.INVALID_TARIFF_TYPE': 'Tipo tariffa non valido',
        'API.INVALID_TENANT_ID': 'ID locatario non valido',
        'API.INVALID_TENANT_NAME': 'Nome locatario non valido',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Descrizione tipo locatario non valida',
        'API.INVALID_TENANT_TYPE_ID': 'ID tipo locatario non valido',
        'API.INVALID_TENANT_TYPE_NAME': 'Nome tipo locatario non valido',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Codice semplificato tipo locatario non valido',
        'API.INVALID_TENANT_UUID': 'UUID locatario non valido',
        'API.INVALID_TEXT_MESSAGE_ID': 'ID messaggio SMS non valido',
        'API.INVALID_TIMEZONE_ID': 'ID fuso orario non valido',
        'API.INVALID_TOKEN': 'Token non valido',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Unità di misura non valida',
        'API.INVALID_UNIT_OF_PRICE': 'Unità di prezzo non valida',
        'API.INVALID_UNITS': 'Unità non valide',
        'API.INVALID_USER_ID': 'ID utente non valido',
        'API.INVALID_USER_NAME': 'Nome utente non valido',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Nome utente o email non validi',
        'API.INVALID_USER_PHONE': 'Telefono utente non valido',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Utente non valido, eseguire nuovamente il login',
        'API.INVALID_USER_UUID': 'UUID utente non valido',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'ID contatore variabile non valido',
        'API.INVALID_VARIABLE_METER_TYPE': 'Tipo contatore variabile non valido',
        'API.INVALID_VARIABLE_NAME': 'Nome variabile non valido',
        'API.INVALID_VERIFICATION_CODE': 'Codice di verifica non valido',
        'API.INVALID_VIRTUAL_METER_ID': 'ID contatore virtuale non valido',
        'API.INVALID_VIRTUAL_METER_NAME': 'Nome contatore virtuale non valido',
        'API.INVALID_VIRTUAL_METER_UUID': 'UUID contatore virtuale non valido',
        'API.INVALID_WEB_MESSAGE_ID': 'ID messaggio web non valido',
        'API.INVALID_WECHAT_MESSAGE_ID': 'ID messaggio WeChat non valido',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'ID calendario lavorativo non valido',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Nome calendario lavorativo non valido',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Impossibile rimuovere file conoscenza dal disco',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'File conoscenza non trovato',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'Contatore principale non appartiene alla stessa categoria energia',
        'API.MASTER_METER_NOT_FOUND': 'Contatore principale non trovato',
        'API.MENU_NOT_FOUND': 'Menu non trovato',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Nome contatore già in uso',
        'API.METER_NOT_FOUND': 'Contatore non trovato',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Contatore variabile non trovato',
        'API.METER_POINT_RELATION_EXISTS': 'Relazione contatore-punto dati già esistente',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Relazione contatore-punto dati non trovata',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Lunghezza nuova password non può superare 100 caratteri',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Giorno non lavorativo non trovato',
        'API.NOT_FOUND': 'Non trovato',
        'API.NOTIFICATION_NOT_FOUND': 'Notifica non trovata',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'File contatore offline non trovato',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nome contatore offline già in uso',
        'API.OFFLINE_METER_NOT_FOUND': 'Contatore offline non trovato',
        'API.INVALID_OFFLINE_METER_VALUE': 'Valore del contatore offline non valido',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Contatore offline variabile non trovato',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Lunghezza vecchia password non può superare 100 caratteri',
        'API.PARENT_SPACE_NOT_FOUND': 'Spazio padre non trovato',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Lunghezza password non può superare 100 caratteri',
        'API.PASSWORDS_MATCH': 'Nuova password identica alla vecchia password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nome punto dati già in uso',
        'API.POINT_NOT_FOUND': 'Punto dati non trovato',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nome privilegio già in uso',
        'API.PRIVILEGE_NOT_FOUND': 'Privilegio non trovato',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nome regola già in uso',
        'API.RULE_NOT_FOUND': 'Regola non trovata',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nome sensore già in uso',
        'API.SENSOR_NOT_FOUND': 'Sensore non trovato',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Relazione sensore-punto dati già esistente',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relazione sensore-punto dati non trovata',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relazione reparto-attrezzatura già esistente',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione reparto-attrezzatura non trovata',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relazione reparto-contatore già esistente',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relazione reparto-contatore non trovata',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nome reparto già in uso',
        'API.SHOPFLOOR_NOT_FOUND': 'Reparto non trovato',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relazione reparto-contatore offline già esistente',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione reparto-contatore offline non trovata',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relazione reparto-punto dati già esistente',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relazione reparto-punto dati non trovata',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relazione reparto-sensore già esistente',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relazione reparto-sensore non trovata',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relazione reparto-contatore virtuale già esistente',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione reparto-contatore virtuale non trovata',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione reparto-calendario lavorativo già esistente',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione reparto-calendario lavorativo non trovata',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Nodo sorgente non trovato',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relazione spazio-attrezzatura combinata già esistente',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione spazio-attrezzatura combinata non trovata',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relazione spazio-attrezzatura già esistente',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relazione spazio-attrezzatura non trovata',
        'API.SPACE_METER_RELATION_EXISTS': 'Relazione spazio-contatore già esistente',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Relazione spazio-contatore non trovata',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nome spazio già in uso',
        'API.SPACE_NOT_FOUND': 'Spazio non trovato',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Spazio non trovato nel privilegio',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relazione spazio-contatore offline già esistente',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione spazio-contatore offline non trovata',
        'API.SPACE_POINT_RELATION_EXISTS': 'Relazione spazio-punto dati già esistente',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relazione spazio-punto dati non trovata',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Relazione spazio-sensore già esistente',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relazione spazio-sensore non trovata',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relazione spazio-reparto già esistente',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relazione spazio-reparto non trovata',
        'API.SPACE_STORE_RELATION_EXISTS': 'Relazione spazio-negozio già esistente',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relazione spazio-negozio non trovata',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Relazione spazio-locatario già esistente',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relazione spazio-locatario non trovata',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relazione spazio-contatore virtuale già esistente',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione spazio-contatore virtuale non trovata',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione spazio-calendario lavorativo già esistente',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione spazio-calendario lavorativo non trovata',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Data/ora inizio deve precedere data/ora fine',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Relazione negozio-contatore già esistente',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Relazione negozio-contatore non trovata',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Nome negozio già in uso',
        'API.STORE_NOT_FOUND': 'Negozio non trovato',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relazione negozio-contatore offline già esistente',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione negozio-contatore offline non trovata',
        'API.STORE_POINT_RELATION_EXISTS': 'Relazione negozio-punto dati già esistente',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Relazione negozio-punto dati non trovata',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Relazione negozio-sensore già esistente',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Relazione negozio-sensore non trovata',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome tipo negozio già in uso',
        'API.STORE_TYPE_NOT_FOUND': 'Tipo negozio non trovato',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Codice semplificato tipo negozio già in uso',
        'API.STORE_TYPE_USED_IN_STORE': 'Tipo negozio già usato nel negozio',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relazione negozio-contatore virtuale già esistente',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione negozio-contatore virtuale non trovata',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione negozio-calendario lavorativo già esistente',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione negozio-calendario lavorativo non trovata',
        'API.TARGET_NODE_NOT_FOUND': 'Nodo destinazione non trovato',
        'API.TARIFF_IN_USE': 'Tariffa in uso',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariffa già associata al centro di costo',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariffa non associata al centro di costo',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nome tariffa già in uso',
        'API.TARIFF_NOT_FOUND': 'Tariffa non trovata',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Relazione locatario-contatore già esistente',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Relazione locatario-contatore non trovata',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nome locatario già in uso',
        'API.TENANT_NOT_FOUND': 'Locatario non trovato',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relazione locatario-contatore offline già esistente',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relazione locatario-contatore offline non trovata',
        'API.TENANT_POINT_RELATION_EXISTS': 'Relazione locatario-punto dati già esistente',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relazione locatario-punto dati non trovata',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Relazione locatario-sensore già esistente',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Relazione locatario-sensore non trovata',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome tipo locatario già in uso',
        'API.TENANT_TYPE_NOT_FOUND': 'Tipo locatario non trovato',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Codice semplificato tipo locatario già in uso',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tipo locatario già usato nel locatario',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relazione locatario-contatore virtuale già esistente',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relazione locatario-contatore virtuale non trovata',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Relazione locatario-calendario lavorativo già esistente',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relazione locatario-calendario lavorativo non trovata',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Messaggio SMS non trovato',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Periodo di report deve essere superiore a 15 minuti',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Esiste relazione con sottocontatori',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Esiste relazione con sottospazi',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Esiste relazione con parametri attrezzatura combinata',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Esiste relazione con attrezzature combinate',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Esiste relazione con sorgenti dati',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Esiste relazione con collegamenti diagramma flusso energia',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Esiste relazione con batterie container accumulo energia',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Esiste relazione con reti container accumulo energia',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Esiste relazione con carichi container accumulo energia',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Esiste relazione con sistemi conversione potenza (PCS) container accumulo energia',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Esiste relazione con parametri attrezzatura',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Esiste relazione con attrezzature',
        'API.THERE_IS_RELATION_WITH_METER': 'Esiste relazione con contatore',
        'API.THERE_IS_RELATION_WITH_METERS': 'Esiste relazione con più contatori',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Esiste relazione con contatore offline',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Esiste relazione con più contatori offline',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Esiste relazione con altri contatori virtuali',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'Esiste relazione con sensori',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Esiste relazione con reparti',
        'API.THERE_IS_RELATION_WITH_SPACES': 'Esiste relazione con spazi',
        'API.THERE_IS_RELATION_WITH_STORES': 'Esiste relazione con negozi',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'Esiste relazione con locatari',
        'API.THERE_IS_RELATION_WITH_USERS': 'Esiste relazione con utenti',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Esiste relazione con contatore virtuale',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Esiste relazione con centrali elettriche virtuali',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Questa sorgente dati è in uso da un contatore',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Questo contatore è in uso da un contatore virtuale',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Questo contatore offline è in uso da un contatore virtuale',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'Spazio non può essere clonato',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'Spazio non può essere eliminato',
        'API.TIMEZONE_NOT_FOUND': 'Fuso orario non trovato',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token non trovato negli header, effettuare il login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Account utente bloccato',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'Account utente scaduto',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'Nome utente già in uso',
        'API.USER_NOT_FOUND': 'Utente non trovato',
        'API.USER_PASSWORD_HAS_EXPIRED': 'Password utente scaduta',
        'API.USER_PRIVILEGE_NOT_FOUND': 'Privilegio utente non trovato',
        'API.USER_SESSION_NOT_FOUND': 'Sessione utente non trovata',
        'API.USER_SESSION_TIMEOUT': 'Sessione utente scaduta',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID utente non trovato negli header, effettuare il login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nome contatore virtuale già in uso',
        'API.VIRTUAL_METER_NOT_FOUND': 'Contatore virtuale non trovato',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Contatore virtuale variabile non trovato',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Punto dati virtuale dovrebbe essere valore analogico',
        'API.WEB_MESSAGE_NOT_FOUND': 'Messaggio web non trovato',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Messaggio WeChat non trovato',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nome calendario lavorativo già in uso',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Calendario lavorativo non trovato',
        MasterMeter: 'Contatore Principale',
        SubMeter: 'Sottocontatore',
        'Power Quality': 'Qualità dell\'Energia',
        'About Power Quality': 'Informazioni sulla Qualità dell\'Energia',
        Category: 'Categoria',
        Type: 'Tipo',
        Limit: 'Limite',
        'Normal Limit': 'Limite Normale',
        'Severe Limit': 'Limite Grave',
        Compliance: 'Tasso di Conformità',
        'Worst Deviation': 'Deviazione Peggiore',
        'Worst Time': 'Ora Peggiore',
        'Severe Exceed Count': 'Conteggio Superamenti Gravi',
        'Worst Unbalance': 'Squilibrio Massimo',
        Hz: 'Hertz',
        voltage: 'tensione',
        current: 'corrente',
        frequency: 'frequenza',
        voltage_deviation: 'deviazione di tensione',
        current_unbalance: 'squilibrio di corrente',
        voltage_unbalance: 'squilibrio di tensione',
        mean_deviation_pct: 'deviazione media(%)',
        p95_abs_deviation_pct: 'deviazione assoluta P95(%)',
        mean_abs_deviation_hz: 'deviazione assoluta media(Hz)',
        frequency_deviation: 'deviazione di frequenza',
        p95_abs_deviation_hz: 'deviazione assoluta P95(Hz)',
        mean_unbalance_pct: 'squilibrio medio(%)',
        p95_unbalance_pct: 'squilibrio P95(%)',
        count: 'conteggio',
        min: 'minimo',
        max: 'massimo',
        mean: 'media',
        std: 'deviazione standard',
        p5: 'P5',
        p95: 'P95'
    }
};
